import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearStore } from "../../store/reducer/accountReducer";
import successGif from "../../assets/images/success.gif";

const Success = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(clearStore());
  }, [dispatch]); 
  return (
    <div className="page">
      <div className="flex-column">
        <div className="kiddies_hero"></div>

        <div className="kiddies_hero-tablet"></div>

        <div className="kiddies_hero-mobile"></div>

        <div className="col-lg-12  m-b-50 ">
          <div className="tab-content p-30" id="myTabContent">
            <div
              className="fade show active"
              id="account_spec"
              role="tabpanel"
              aria-labelledby="account_spec-tab"
            >
              {/* <!-- CHILD INFORMATION --> */}
              <div className="section-info m-b-50">
                {/* <!-- <div className="row"> --> */}

                {/* <!-- Personal Information --> */}
                <div className="col-lg-12 col-md-12 col-sm-12 m-b-30 d-flex align-items-center justify-content-between">
                  <div className="first-div">
                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className="section-title m-b-30 m-t-30 text-suntrust">
                        Account creation in process
                      </div>

                      <div className="section-sub-title m-b-30">
                        Your application is currently under review, an email
                        notification will be sent to you once the process is
                        completed.{" "}
                      </div>

                      <div className="form-group m-b-20">
                        <button onClick={() => navigate("/openKiddiesAccount")} className="btn btn-lg btn-suntrust font-weight-500">
                          Open a new Account
                        </button>
                      </div>
                    </div>

                    <div className="section-forms col-lg-3 col-md-12 col-sm-12">
                      <div className="col-lg-12">
                        <div className="row">
                          <img src="../assets/images/complete.png" alt="" />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="second-div">
                    <img
                      src={successGif}
                      alt="successImage"
                      style={{ width: "70%", height: "70%" }}
                    />
                  </div>

                </div>

                {/* <!-- </div> --> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
